import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import GeneralLedgerWorkspace from './GeneralLedgerWorkspace';
import ChartOfAccountsWorkspace from './ChartOfAccountsWorkspace';
import CustomerCollection360Page from './CustomerCollection360Page';
import FinancialReportingControlCenter from './FinancialReportingControlCenter';
import GSTReportsPage from './GSTReportsPage';
import TDSReportsPage from './TDSReportsPage';
import AgeingReportsPage from './AgeingReportsPage';
import DayBookPage from './DayBookPage';
import BankReconciliationPage from './BankReconciliationPage';
import FinanceCommandCenter from './FinanceCommandCenter';
import CollectionsPage from './CollectionsPage';
import CostProfitControlCenter from './CostProfitControlCenter';
import CostCenter360Page from './CostCenter360Page';
import ProfitCenter360Page from './ProfitCenter360Page';
import BudgetControlCenter from './BudgetControlCenter';
import Budget360Page from './Budget360Page';
import RecurringJournalControlCenter from './RecurringJournalControlCenter';
import PeriodCloseControlCenter from './PeriodCloseControlCenter';
import Period360Page from './Period360Page';
import CreditDebitNotesPage from './CreditDebitNotesPage';
import JournalEntryNewPage from './JournalEntryNewPage';
import BudgetWorkspacePage from './BudgetWorkspacePage';
import AccountWorkspacePage from './AccountWorkspacePage';
import RecurringJournalWorkspacePage from './RecurringJournalWorkspacePage';
import JournalControlCenter from './JournalControlCenter';
import Journal360Page from './Journal360Page';
import ExpensePage from './ExpensePage';
import ExpenseFormPage from './ExpenseFormPage';
import ExpenseDetailPage from './ExpenseDetailPage';
import HsnCodesPage from './HsnCodesPage';
import PaymentAllocationPage from './PaymentAllocationPage';
import BankStatementImportPage from './BankStatementImportPage';
import CustomerPaymentPage from './CustomerPaymentPage';
import CustomerPaymentNewPage from './CustomerPaymentNewPage';
import CustomerPaymentDetailPage from './CustomerPaymentDetailPage';

const JournalEntries: React.FC = () => <JournalControlCenter />;

const FinancePage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<FinanceCommandCenter />} />
      <Route path="command-center" element={<FinanceCommandCenter />} />
      <Route path="overview" element={<Navigate to="/finance" replace />} />
      <Route path="accounts" element={<ChartOfAccountsWorkspace />} />
      <Route path="accounts/new" element={<AccountWorkspacePage />} />
      <Route path="accounts/:id/edit" element={<AccountWorkspacePage />} />
      <Route path="journal" element={<JournalEntries />} />
      <Route path="journal/new" element={<JournalEntryNewPage />} />
      <Route path="journal/:id" element={<Journal360Page />} />
      <Route path="ledger" element={<GeneralLedgerWorkspace />} />
      <Route path="reports" element={<FinancialReportingControlCenter />} />
      <Route path="gst-reports" element={<GSTReportsPage />} />
      <Route path="tds-reports" element={<TDSReportsPage />} />
      <Route path="ageing" element={<AgeingReportsPage />} />
      <Route path="day-book" element={<DayBookPage />} />
      <Route path="bank-reconciliation" element={<BankReconciliationPage />} />
      {/* New enterprise finance workspaces */}
      <Route path="credit-debit-notes" element={<CreditDebitNotesPage />} />
      <Route path="collections" element={<CollectionsPage />} />
      <Route path="collections/:customerId" element={<CustomerCollection360Page />} />
      <Route path="customer-payments" element={<CustomerPaymentPage />} />
      <Route path="customer-payments/new" element={<CustomerPaymentNewPage />} />
      <Route path="customer-payments/:id" element={<CustomerPaymentDetailPage />} />
      <Route path="budgets" element={<BudgetControlCenter />} />
      <Route path="budgets/new" element={<BudgetWorkspacePage />} />
      <Route path="budgets/:id/edit" element={<BudgetWorkspacePage />} />
      <Route path="budgets/:id" element={<Budget360Page />} />
      <Route path="cost-centers" element={<CostProfitControlCenter />} />
      <Route path="cost-centers/:id" element={<CostCenter360Page />} />
      <Route path="profit-centers/:id" element={<ProfitCenter360Page />} />
      <Route path="recurring-journals" element={<RecurringJournalControlCenter />} />
      <Route path="recurring-journals/new" element={<RecurringJournalWorkspacePage />} />
      <Route path="period-close" element={<PeriodCloseControlCenter />} />
      <Route path="period-close/:fy/:period" element={<Period360Page />} />
      <Route path="expenses" element={<ExpensePage />} />
      <Route path="expenses/new" element={<ExpenseFormPage />} />
      <Route path="expenses/:id/edit" element={<ExpenseFormPage />} />
      <Route path="expenses/:id" element={<ExpenseDetailPage />} />
      <Route path="hsn-codes" element={<HsnCodesPage />} />
      <Route path="payment-allocations" element={<PaymentAllocationPage />} />
      <Route path="bank-statements" element={<BankStatementImportPage />} />
    </Routes>
  );
};

export default FinancePage;